<template>
    <section
        id="about-section" 
        class="flex flex-col md:flex-row md:gap-10 py-20 mb-20"
        :class="context.isDarkMode ? 'bg-void' : 'bg-white'"
    >
        <div class="w-full md:w-1/2 mb-20 ml-0 px-10 md:mb-0 md:px-10 md:ml-10 md:ml-20 lg:ml-25 flex flex-col justify-center">
            <p class="text-2xl font-thin" :class="context.isDarkMode ? 'text-third-color' : 'text-first-color'">
                {{ translationHandler.translate('cervo digital', 'ucfirst') }}
            </p>
            <p class="text-2xl font-semibold my-4" :class="context.isDarkMode ? 'text-silver' : 'text-void'">
                {{ translationHandler.translate('we are an agency specialized in website development, web applications, and digital marketing.', 'ucfirst') }}
            </p>
            <p class="text-lg font-semibold" :class="context.isDarkMode ? 'text-main-gray' : 'text-semidark-silver'">
                {{ translationHandler.translate('we create innovative solutions for companies looking to grow in the digital environment.', 'ucfirst') }}
            </p>

            <div class="flex gap-2 content-center primary-button max-width-md grow-effect rounded-3xl px-4 shadow w-auto mt-10" @click="urlHandler.redirect('budget')">
                <span class="text-lg lg:text-lg 2xl:text-2xl my-auto text-silver font-semibold mx-auto md:mx-0">
                    {{ translationHandler.translate('get started', 'capitalize') }}
                </span>
                <i class="text-silver pi pi-objects-column border border-second-color rounded-full bg-second-color p-2 my-auto shadow ml-auto"></i>
            </div>
        </div>

        <div class="w-full lg:w-1/2 md:bg-cover bg-right bg-no-repeat" :style="getStyles()">
            <div class="flex flex-wrap gap-10 md:gap-5 justify-center px-10 md:px-0">
                <div 
                    class="shadow-2xl px-5 py-10 md:px-3 md:py-8 rounded-2xl w-full md:w-2/4 lg:w-2/5 xl:w-2/6" 
                    :class="context.isDarkMode ? 'bg-semidark-silver text-silver' : 'bg-white text-void border border-light-white'"
                    v-for="(item, index) of items" 
                    :key="index"
                >
                    <div class="w-full mx-auto">
                        <img :src="item.img" alt="about section image" class="w-full lg:w-2/3 mx-auto rounded-3xl">
                    </div>
                    <p class="text-xl font-semibold my-5 text-center" :class="context.isDarkMode ? 'text-silver' : 'text-void'">
                        {{ translationHandler.translate(item.title, 'capitalize') }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

import { useContextStore } from '@/stores/context';
import translationHandler from '@/composables/handlers/TranslationHandler';
import { ref } from 'vue';
import urlHandler from '@/composables/urlHandler';

const context = useContextStore();

const items = ref([
    { title: 'identity and innovation', img: require('@/assets/images/about/identity_and_innovation.png') },
    { title: 'authority and recognition', img: require('@/assets/images/about/authority_and_recognition.png') },
    { title: 'expansion and new opportunities', img: require('@/assets/images/about/expansion_and_new_opportunities.png') },
    { title: 'efficiency and added value', img: require('@/assets/images/about/efficiency_and_added_value.png') }
]);

function getStyles() {
    const imgName = `purple-background-${context.isDarkMode ? 'dark' : 'light'}`;
    const backgroundImage = require(`@/assets/images/${imgName}.png`);
    return {
        'background-image': `url(${backgroundImage})`
    };
}

</script>